/**
 * Implements a KendoUI AutoComplete as a Marionette Behavior.
 */

import Marionette from "backbone.marionette";

import "kendo.core";
import "kendo.data";
import "kendo.fx";
import "kendo.popup";
import "kendo.list";
import "kendo.autocomplete";

class AutoComplete extends Marionette.Behavior {
  defaults() {
    return {
      // behavior defaults
      selector: ".rvc-autocomplete",
      opts: {
        clearButton: false,
        highlightFirst: true,
        delay: 500,
        minLength: 2,
        // options dropdown will not wrap the text, useful when input is small.
        autoWidth: true,
        // avoid submitting a * query when field is cleared
        enforceMinLength: true,
        placeholder: "Search...",
        // expects a data array or an instance of kendo.data.DataSource
        dataSource: [],
        noDataTemplate: "No data found",
      },
    };
  }

  initialize() {
    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);
  }

  onRender() {
    const instance = this.$(this.options.selector).kendoAutoComplete(
      this.options.opts
    );

    this.api = instance.getKendoAutoComplete();
  }
}

export { AutoComplete as default };
